module.exports = __webpack_public_path__ + "static/media/menu.1111785d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/menu.svg
// module id = 606
// module chunks = 0